// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__cwjCz","label":"Category_label__CBwR1","content":"Category_content__fsrZk","header":"Category_header__2T5-L","location":"Category_location__kc1eR"};